"use client"

const SEGMENTS = 6

type SearchingWormProps = {
  label?: string
}

/**
 * Inchworm-style loading indicator for chat search / reply wait.
 * Keyframes are inlined so animation still works when Cloudflare serves a
 * stale Tailwind CSS chunk (same filename, old content).
 */
export default function SearchingWorm({
  label = "กำลังค้นหาและตอบ…",
}: SearchingWormProps) {
  return (
    <div
      className="flex items-center gap-3"
      role="status"
      aria-live="polite"
      aria-label={label}
    >
      <style>{`
        @keyframes vx-chat-worm {
          0%, 100% { transform: translateY(0) scaleY(1) scaleX(1); }
          35% { transform: translateY(-7px) scaleY(1.2) scaleX(0.88); }
          55% { transform: translateY(1px) scaleY(0.85) scaleX(1.12); }
        }
        @keyframes vx-chat-worm-crawl {
          0%, 100% { transform: translateX(0); }
          50% { transform: translateX(8px); }
        }
        .vx-chat-worm-track {
          display: flex;
          align-items: flex-end;
          gap: 3px;
          padding-block: 4px;
          animation: vx-chat-worm-crawl 1.6s ease-in-out infinite;
        }
        .vx-chat-worm-seg {
          position: relative;
          display: block;
          flex-shrink: 0;
          border-radius: 9999px;
          background: #006fff;
          animation: vx-chat-worm 0.9s cubic-bezier(0.45, 0.05, 0.55, 0.95) infinite;
        }
        .vx-chat-worm-seg--body {
          width: 10px;
          height: 10px;
        }
        .vx-chat-worm-seg--head {
          width: 12px;
          height: 12px;
        }
        .vx-chat-worm-eye {
          position: absolute;
          top: 5px;
          width: 3px;
          height: 3px;
          border-radius: 9999px;
          background: #fff;
        }
        @media (prefers-reduced-motion: reduce) {
          .vx-chat-worm-track,
          .vx-chat-worm-seg {
            animation: none !important;
          }
        }
      `}</style>
      <div className="vx-chat-worm-track" aria-hidden>
        {Array.from({ length: SEGMENTS }, (_, i) => {
          const isHead = i === SEGMENTS - 1
          return (
            <span
              key={i}
              className={[
                "vx-chat-worm-seg",
                isHead ? "vx-chat-worm-seg--head" : "vx-chat-worm-seg--body",
              ].join(" ")}
              style={{ animationDelay: `${i * 0.1}s` }}
            >
              {isHead ? (
                <>
                  <span
                    className="vx-chat-worm-eye"
                    style={{ left: 5 }}
                  />
                  <span
                    className="vx-chat-worm-eye"
                    style={{ right: 5 }}
                  />
                </>
              ) : null}
            </span>
          )
        })}
      </div>
      <span className="text-[15px] text-vx-muted">{label}</span>
    </div>
  )
}
